import { MeasurementMarkerDto, SessionKindGroupName } from 'types/models/SessionsPageData';
import { MeasurementDetailDto, SessionDetailsResponseDto } from 'types/models/MeasurementDetail';

/**
 * Adapts a session-page kick to the marker shape the shared pitch top-view chart draws, so that chart is reused as is.
 * The chart plots kick origins (like the aggregate views), so landing and goal-plane fields stay empty.
 */
export function detailToMarker(kick: MeasurementDetailDto, details: SessionDetailsResponseDto): MeasurementMarkerDto {
  return {
    id: kick.measurementId,
    sessionId: kick.sessionId,
    playerId: kick.playerId ?? '',
    playerName: kick.playerName,
    kind: (details.kind ?? '') as SessionKindGroupName,
    kindRaw: details.sessionType,
    result: kick.kickResult,
    capturedAtUtc: kick.capturedAtUtc,
    kickX: kick.kickX ?? null,
    kickZ: kick.kickZ ?? null,
    goalY: null,
    goalZ: null,
    landingX: null,
    landingZ: null,
    ballSpeed: kick.ballSpeed ?? null,
    hangTime: kick.hangTime ?? null,
    reachableRegionStart: kick.reachableRegionStart ?? null,
    reachableRegionEnd: kick.reachableRegionEnd ?? null,
    onTarget: kick.onTarget ?? null,
    trajectorySamples: kick.trajectorySamples ?? null,
    videoCount: kick.videos.length,
  };
}
